import React, { SelectHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Select } from '../Select/Select';

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  rating?: number;
}

const RatingMobile = ({ onChange, rating }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className='block md:hidden'>
      <Select id='rating-mobile-select' label='Rating' onChange={onChange} value={rating}>
        <option value='0'>0 - {t('components.feedback.notLikely')}</option>
        <option value='1'>1</option>
        <option value='2'>2</option>
        <option value='3'>3</option>
        <option value='4'>4</option>
        <option value='5'>5</option>
        <option value='6'>6</option>
        <option value='7'>7</option>
        <option value='8'>8</option>
        <option value='9'>9</option>
        <option value='10'>10 - {t('components.feedback.veryLikely')}</option>
      </Select>
    </div>
  );
};

export { RatingMobile };
